'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _FormGroup = require('./FormGroup');

var _FormGroup2 = _interopRequireDefault(_FormGroup);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

exports["default"] = _FormGroup2["default"];
module.exports = exports['default'];